import React from 'react';
import { useSelector } from 'react-redux';
import SectionGrid from '~/app/Components/Dashboard/OverviewV2/primitives/SectionGrid.jsx';

const BusinessStateReturnsSubmitted = () => {
  const businessStateFedReturnsState = useSelector(state => state.dashboardOverview.heroCards);
  const businessStateFedReturnsData = businessStateFedReturnsState?.data?.returnsSubmittedCorp;

  const stateReturnCards = [
    {
      key: 1,
      count: businessStateFedReturnsData?.StReject || 0,
      title: 'State Reject',
      loading: businessStateFedReturnsState?.loading,
      error: Boolean(
        businessStateFedReturnsState?.error ||
          (!businessStateFedReturnsState?.loading && !businessStateFedReturnsData),
      ),
      entity: 'Business',
    },
  ];

  return (
    <SectionGrid title="Business State Returns Submitted" cards={stateReturnCards}></SectionGrid>
  );
};

export default BusinessStateReturnsSubmitted;
